import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoin1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCoin1"><Path d="M13.5 21.25C17.7802 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.7802 2.75 13.5 2.75M13.5 21.25C9.21979 21.25 5.75 17.1086 5.75 12C5.75 6.89137 9.21979 2.75 13.5 2.75M13.5 21.25H10.5C6.21979 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.21979 2.75 10.5 2.75H13.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconCoin1;
